/** Single source for Show more / Show less copy used by ShowMoreToggle and callers. */
export const SHOW_MORE_LABEL = 'Show more';
export const SHOW_LESS_LABEL = 'Show less';
